export default __webpack_public_path__ + "static/media/telugu.a58f7e39.svg";